import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../../../../translation/translation_container';
import { Checkbox } from '../../../../form/floating_label/checkbox';

function LightboxFilterCheckbox(props) {
    return (
        <div className="lightbox-filter-section__filter">
            <TranslationContainer
                targetProperties={{
                    label: { translationKey: props.labelTranslationKey }
                }}
            >
                <Checkbox
                    name={props.name}
                    checked={props.checked}
                    onChange={props.onChange}
                    disabled={props.disabled}
                    label="will-be-replaced"
                />
            </TranslationContainer>
        </div>
    );
}

LightboxFilterCheckbox.propTypes = {
    name: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    labelTranslationKey: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

export { LightboxFilterCheckbox };
